import React from "react";
import { Button, useTheme } from "@mui/material";

interface ActivityAddButtonProps {
  onClick: () => void;
}

/**
 * Add button used in activity overviews.
 */
const ActivityAddButton = ({ onClick }: ActivityAddButtonProps) => {
  const theme = useTheme();

  return (
    <Button
      onClick={onClick}
      variant="contained"
      sx={{
        marginTop: "20px",
        marginBottom: "20px",
        border: "0",
        backgroundColor: theme.palette.primary.main,
        color: "white",
        "&:hover": {
          color: "black",
        },
      }}
    >
      Aktivität hinzufügen
    </Button>
  );
};

export default ActivityAddButton;
